module.exports = __webpack_public_path__ + "static/media/who-7.40082ceb.jpg";